import PersonalizedPanel, { HealthScoreChange } from "./PersonalisedPanel";
import { Stack, Typography } from "@mui/material";

export default function PersonalizedPanelExamples() {
  const decreaseChange: HealthScoreChange = {
    points: 3,
    direction: "decrease",
    timeFrameKey: "PersonalizedHealth.card.timeFrame.fromLastWeek",
  };

  const increaseChange: HealthScoreChange = {
    points: 5,
    direction: "increase",
    timeFrameKey: "PersonalizedHealth.card.timeFrame.fromLastMonth",
  };

  return (
    <Stack mt={4} gap={4} maxWidth={400}>
      <Stack gap={1}>
        <Typography fontWeight={600} variant="h3" fontSize={16}>
          CTA card (no health score)
        </Typography>
        <PersonalizedPanel />
      </Stack>

      <Stack gap={1}>
        <Typography fontWeight={600} variant="h3" fontSize={16}>
          Health score card – score only
        </Typography>
        <PersonalizedPanel healthScore={51} lastUpdated="2025-05-01" />
      </Stack>

      <Stack gap={1}>
        <Typography fontWeight={600} variant="h3" fontSize={16}>
          Health score card – with decrease
        </Typography>
        <PersonalizedPanel
          healthScore={51}
          lastUpdated="2025-05-01"
          change={decreaseChange}
        />
      </Stack>

      <Stack gap={1}>
        <Typography fontWeight={600} variant="h3" fontSize={16}>
          Health score card – with increase
        </Typography>
        <PersonalizedPanel
          healthScore={62}
          lastUpdated="2025-05-01"
          change={increaseChange}
        />
      </Stack>

      <Stack gap={1}>
        <Typography fontWeight={600} variant="h3" fontSize={16}>
          Health score card – high score (green)
        </Typography>
        <PersonalizedPanel healthScore={75} lastUpdated="2025-05-01" />
      </Stack>

      <Stack gap={1}>
        <Typography fontWeight={600} variant="h3" fontSize={16}>
          Health score card – low score
        </Typography>
        <PersonalizedPanel healthScore={35} lastUpdated="2025-05-01" />
      </Stack>
    </Stack>
  );
}
